export function validateInput(input, errorCallback) {
  if (input.value.length == 0) {
    errorCallback();
    return false;
  }

  return true;
}